import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import './index.scss'
import './index.css'
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'

const TemplateWrapper = ({ children }) => (
  <Navigation>
    <Helmet
      title="OLLIE"
      meta={[
        { name: 'Online Legal Library and Information for Entrepreneurs', content: 'An online library of lay-friendly materials to assist new entrepreneurs in learning what they need to know about the law.' }
      ]}
    />
    <div>
      {children()}
    </div>
    <Footer/>
  </Navigation>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js